<div class="event-header bg-primary">
  <a
    [routerLink]="[
      '/app/main',
      {
        outlets: {
          navigation: ['event', eventItem?.event?.id],
          content: ['event-markets', eventItem?.event?.id],
        },
      },
    ]"
    class="event-title text-secondary">
    @if (eventItem?.event?.competitionName) {
      <span>{{ eventItem?.event?.competitionName }} - </span>
    }
    <b>{{ eventItem?.event?.name }}</b></a
  >
  @if (eventItem && (showStartTime || isInPlay())) {
    <span class="ipl-status text-secondary">
      @if (showStartTime) {
        <app-market-countdown [marketStartTime]="eventItem?.event?.openDate" />
      }
      @if (isInPlay()) {
        @if (showStartTime) {
          <div class="st-divider bg-secondary"></div>
        }
        <span>IN-PLAY</span>
      }
    </span>
  }
  @let placementPermitted = wlConfigService.showFeature("preMatchPlacement");
  @let isWithin45Minutes = wlConfigService.isWithin45Minutes(eventItem?.event?.openDate);
  <!--      <span class="text-secondary"> Is within 45 mins {{ isWithin45Minutes }} </span>-->
  @if (!placementPermitted && !isWithin45Minutes) {
    <span class="text-secondary">{{ "Betting not allowed until 45 minutes before event start" | translate }}</span>
  }
</div>
